import { FC, useEffect } from "react";
import {
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Connection, UsernamePasswordFormValues } from "types";
import { Controller, useForm } from "react-hook-form";

type Props = {
  onChange: (values: UsernamePasswordFormValues) => void;
  initialData?: Connection;
};

// the idea here for the future is to have a Meltano connection that can handle multiple connection types
// we will create an endpoint which will tell the frontend which paramters to ask for based on the connection type
// for now we will just use static ones for Shopify

const MeltanoConnection: FC<Props> = ({ initialData, onChange }) => {
  const { t } = useTranslation();

  const {
    control,
    watch,
    formState: { errors, isValid },
  } = useForm<UsernamePasswordFormValues>({
    defaultValues: {
      username: initialData?.metadata?.store || "",
      password: "",
    },
    mode: "onChange", // Validate on each change
  });

  const formValues = watch();

  // Pass form values and validity to parent
  useEffect(() => {
    onChange({
      ...formValues,
      isValid: Boolean(formValues.username && formValues.password) // Simple validation
    });
  }, [formValues, onChange]);

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">
        {t("connection:connection_details")}
      </Typography>

      <Controller
        name="username"
        control={control}
        rules={{
          required: t("alert:missing_value"),
        }}
        render={({ field }) => (
          <TextField
            {...field}
            label={"store"}
            variant="outlined"
            fullWidth
            error={!!errors.username}
            helperText={errors.username ? errors.username.message : ""}
            disabled={!!initialData}
          />
        )}
      />
      
      {!initialData && (
        <Controller
          name="password"
          control={control}
          rules={{
            required: t("alert:missing_value"),
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label={"access token"}
              variant="outlined"
              fullWidth
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ""}
              type={"password"}
            />
          )}
        />
      )}
      
    </Stack>
  );
};

export default MeltanoConnection;
